module.exports = __webpack_public_path__ + "img/pause-alle.907e88ff.svg";